import React from "react"
import styled from "styled-components"

import { Section, Container } from "../global"

const CARDS = [
  {
    emoji: "📸",
    title: "Mood & photo check-ins",
    text: "A mood, a note, a snapshot — every day becomes a memory you can look back on.",
  },
  {
    emoji: "🏅",
    title: "Records & milestones",
    text: "Longest-streak trophies, milestone days, and confetti when you earn them. Your effort is celebrated.",
  },
  {
    emoji: "📖",
    title: "Past Chapters",
    text: "Retired an intention? It's honored, never erased. Every chapter of your story stays with you.",
  },
  {
    emoji: "🕰️",
    title: "BTC time machine",
    text: "See what Bitcoin was worth on your Day One versus today. Your streak has a timeline of its own.",
  },
]

const Memories = () => (
  <Section id="memories">
    <StyledContainer>
      <Subtitle>Your story, kept</Subtitle>
      <SectionTitle>Every day you add is a page</SectionTitle>
      <LeadText>
        Day isn't just a counter. It quietly keeps the story of your showing up
        — the moods, the milestones, the chapters.
      </LeadText>
      <CardsGrid>
        {CARDS.map((card) => (
          <Card key={card.title}>
            <CardEmoji>{card.emoji}</CardEmoji>
            <CardTitle>{card.title}</CardTitle>
            <CardText>{card.text}</CardText>
          </Card>
        ))}
      </CardsGrid>
    </StyledContainer>
  </Section>
)

export default Memories

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 16px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;
`

const LeadText = styled.p`
  max-width: 560px;
  margin: 0 auto 48px;
  text-align: center;
  color: ${(props) => props.theme.color.black.light};
  font-size: 18px;
  line-height: 28px;
`

const CardsGrid = styled.div`
  max-width: 900px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  grid-column-gap: 32px;
  grid-row-gap: 32px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 32px;
  }
`

const Card = styled.div`
  background: #fffaf1;
  border: 1px solid #ffe9c7;
  border-radius: 20px;
  padding: 28px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(219, 152, 64, 0.18);
  }
`

const CardEmoji = styled.div`
  font-size: 34px;
  margin-bottom: 12px;
`

const CardTitle = styled.h4`
  color: ${(props) => props.theme.color.primary};
  margin: 0 0 10px;
`

const CardText = styled.p`
  margin: 0;
  color: ${(props) => props.theme.color.black.light};
  line-height: 24px;
`
